import {ResolveFn} from "@angular/router";
import {inject} from "@angular/core";
import {AuthService} from "./services/auth.service";
import {AppPermissions} from "./app-permissions";

export const authRedirectResolver: ResolveFn<string> = () => {
    const authService = inject(AuthService);

    if (authService.hasRole(AppPermissions.STANDARD)) {
        return '';
    } else {
        return 'not-found';
    }
};
